import jquery from "jquery";
window.jQuery = window.$ = jquery;

// Bootstrap Framework
import "@popperjs/core";
import "bootstrap";

import "slick-carousel";
import hcSticky from "hc-sticky";
import AfterViewportJs from "@lysla/afterviewportjs";
import "animate.css";
import WOW from "wow.js";
import { Fancybox } from "@fancyapps/ui/dist/fancybox/fancybox.esm.js";

//#region animate.css triggered on viewport
var wow = new WOW({
  boxClass: "wow",
  animateClass: "animated",
  mobile: false,
  offset: 0,
});
wow.init();
//#endregion

//#region offcavas menu mobile e filters
$("[data-trigger]").on("click", function () {
  var trigger_id = $(this).attr("data-trigger");
  $(trigger_id).toggleClass("show");
  $("body").toggleClass("offcanvas-active");
});
$(".close-icon").on("click", function (e) {
  $("#navbarMain").removeClass("show");
  $("body").removeClass("offcanvas-active");
});

//#endregion

//#region stickybar
document.addEventListener("DOMContentLoaded", function () {
  new hcSticky(".stickybar", {
    stickTo: "body",
    stickyClass: "stickybar--sticked",
  });
});
//#endregion

//#region class on active nav link
document.addEventListener("DOMContentLoaded", function () {
  const links = document.querySelectorAll(".nav-item .nav-link");

  links.forEach((link) => {
    let slug = link.getAttribute("href").split("/").reverse()[0];
    if (window.location.href.indexOf(slug) > -1) {
      link.classList.add("active");
    }

    if (window.location.href === link.getAttribute("href")) {
      link.classList.add("active");
    }
  });
});

//#endregion

//#region animated numbers
$(function () {
  $(document).on("scroll", startCounter);
  function startCounter() {
    let scrollY = (window.pageYOffset || document.documentElement.scrollTop) + window.innerHeight;
    let divPos = $("#counter-container").offset().top;

    if (scrollY > divPos) {
      $(document).off("scroll", startCounter);

      $(".animation-numbers__container__number").each(function () {
        var $this = $(this);
        var decimal = $(this).data("decimal");
        jQuery({
          Counter: 0,
        }).animate(
          {
            Counter: $this.text().replace(/,/g, ""),
          },
          {
            duration: 1000,
            easing: "swing",
            step: function () {
              $this.text(commaSeparateNumber(Math.floor(this.Counter)));
            },
            complete: function () {
              $this.text(commaSeparateNumber(decimal ? this.Counter.toFixed(decimal) : this.Counter));
            },
          }
        );
      });

      function commaSeparateNumber(num) {
        return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      }
    }
  }
});
//#endregion

//#region slider
var $status = $(".pagingInfo");
var $slickElement = $(".sliderhome");

$slickElement.on("init reInit afterChange", function (event, slick, currentSlide, nextSlide) {
  //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
  var i = (currentSlide ? currentSlide : 0) + 1;
  $status.text(i + "/" + slick.slideCount);
});

$(function () {
  $(".sliderhome").slick({
    infinite: true,
    slidesToShow: 1,
    dots: true,
    arrows: false,
    speed: 600,
    autoplay: false,
    autoplaySpeed: 3000,
    appendDots: $(".sliderhome__dots"),
    dotsClass: "slick-dots",
  });
  $(".slider-card").slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 5000,
    dots: true,
    arrows: true,
    appendArrows: $(".slider-card-arrow-container"),
    prevArrow: ".slider-card-prev-arrow",
    nextArrow: ".slider-card-next-arrow",
    responsive: [
      {
        breakpoint: 1279,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
          arrows: false,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
          arrows: false,
        },
      },
    ],
  });
  $(".timeline__slider").slick({
    dots: false,
    arrows: true,
    speed: 800,
    autoplay: true,
    autoplaySpeed: 5000,
    cssEase: "linear",
    slidesToShow: 4,
    slidesToScroll: 1,
    swipe: true,
    appendArrows: $(".timeline-arrow-container"),
    prevArrow: ".timeline-prev-arrow",
    nextArrow: ".timeline-next-arrow",
    responsive: [
      {
        breakpoint: 1279,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 2,
          infinite: false,
          dots: true,
          arrows: false,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
          arrows: false,
          autoplay: false,
          autoplaySpeed: 0,
          speed: 400,
        },
      },
    ],
  });
});
//#endregion
//#region popup
/* 

  console.log("DOM fully loaded and parsed");

  const modal = document.getElementById("video-modal");
  const closeButton = document.querySelector(".close-button");
  const youtubeIframe = document.querySelector("#video-modal iframe");

  // Funzioni per la gestione dei cookie
  function setCookie(name, value, days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    const expires = "expires=" + date.toUTCString();
    document.cookie = name + "=" + value + ";" + expires + ";path=/";
    console.log("Cookie set:", name, value);
  }

  function getCookie(name) {
    const cookieName = name + "=";
    const decodedCookie = decodeURIComponent(document.cookie);
    const cookieArray = decodedCookie.split(";");
    for (let i = 0; i < cookieArray.length; i++) {
      let cookie = cookieArray[i];
      while (cookie.charAt(0) === " ") {
        cookie = cookie.substring(1);
      }
      if (cookie.indexOf(cookieName) === 0) {
        return cookie.substring(cookieName.length, cookie.length);
      }
    }
    console.log("Cookie not found:", name);
    return null;
  }

  // Mostra la modale se il cookie non è presente
  if (!getCookie("videoModalShown")) {
    modal.style.display = "block";
    console.log("Modal shown");

    // Verifica se l'iframe è caricato e se l'autoplay funziona
    youtubeIframe.onload = function () {
      console.log("YouTube iframe loaded");
      if (youtubeIframe.src.includes("&autoplay=1")) {
        console.log("YouTube autoplay parameter present");
      } else {
        console.log("YouTube autoplay parameter missing");
      }
    };

    setCookie("videoModalShown", "true", 7);
  }

  // Chiudi la modale e stoppa il video
  closeButton.addEventListener("click", function () {
    modal.style.display = "none";
    youtubeIframe.src = youtubeIframe.src.replace("&autoplay=1", "");
    console.log("Modal hidden, autoplay removed");
  });
}); */
import { Modal } from "bootstrap";

document.addEventListener("DOMContentLoaded", function () {
  console.log("DOM fully loaded and parsed");

  const videoModalElement = document.getElementById("video-modal");
  const video = document.getElementById("video-inside-modal");

  if (!videoModalElement || !video) return;

  const isHomepage = () => {
    const path = window.location.pathname;
    return path === "/" || path === "/it/" || path === "/it/home-page" || path === "/en/" || path === "/en/home-page";
  };

  if (isHomepage() && !localStorage.getItem("videoModalShown")) {
    const videoModal = new Modal(videoModalElement);

    // Appena il modale si apre
    videoModalElement.addEventListener("shown.bs.modal", function () {
      console.log("Modal shown, playing video...");
      video.currentTime = 0; // Parte dall'inizio
      video.muted = true; // Silenziato
      video.play();
    });

    // Quando il modale si chiude
    videoModalElement.addEventListener("hidden.bs.modal", function () {
      console.log("Modal hidden, stopping video...");
      video.pause();
      video.currentTime = 0; // Reset video
      localStorage.setItem("videoModalShown", "true"); // Salva che l'utente l'ha visto
    });

    videoModal.show();
  }
});

//#endregion
